import { Component, OnDestroy, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid/dist/lib/entities/gridOptions';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ServiceProviderService } from 'app/core/services/service-provider.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-history-service-provider',
  templateUrl: './history-service-provider.component.html',
  styleUrls: ['./history-service-provider.component.scss']
})
export class HistoryServiceProviderComponent implements OnInit, OnDestroy {

  protected grid: GridOptions;
  private subscriptions: Subscription[] = [];

  constructor(private serviceProviderService: ServiceProviderService,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
      this.configureGrid();
  }

  ngOnInit() {
    this.getIdServiceProvider();
  }

  getIdServiceProvider() {
    this.subscriptions.push(
      this.serviceProviderService.serviceProvId$.subscribe((serviceProvId: number) => {
        if (serviceProvId) {
          this.getHistoryServiceProvider(serviceProvId);
        }
      }, error => {
        this.sweetAlertHelper.captureException(error);
      })
    );
  }

  getHistoryServiceProvider(serviceProvId: number){
    this.serviceProviderService.getHistoryServiceProvider(serviceProvId).subscribe(history => {
      if (history) {
        this.grid.api.setRowData(history);
      }
    }, err => {
      this.sweetAlertHelper.captureException(err);
    });
  }

  private configureGrid() {
    this.grid = <GridOptions>{
      enableFilter: true,
      enableSorting: true,
      enableColResize: true,
      columnDefs: [{
        headerName: 'Date',
        field: 'dateformatted',
        colId: 'date',
        width: 80,
      },
      {
        headerName: 'Time',
        field: 'timeformatted',
        colId: 'time',
        width: 80
      },
      {
        headerName: 'Description',
        field: 'description',
        colId: 'company',
        width: 380
      },
      {
        headerName: 'User',
        field: 'userprofile.fullname',
        colId: 'user',
        width: 110
      },
      ],
      onGridReady: () => {
        this.grid.api.sizeColumnsToFit();
        this.grid.api.setRowData([]);
      },
    };
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/service-provider/components/history-service-provider/history-service-provider.component.ts